import { faBagShopping, faBurgerGlass, faCalendarDay, faLaptopMobile, faMug } from "@fortawesome/pro-light-svg-icons"
import { ButtonConfigType } from "./StandardOrderTypeFilter"

// Order type for filtering purposes
export enum OrderFilterType {
    ALL = "ALL",
    POS = "POS",
    MEETING_SERVICE = "MEETING_SERVICE",
}

// Configuration for order filtering buttons
export const orderFilterButtonConfig: ButtonConfigType<OrderFilterType>[] = [
    {
        value: OrderFilterType.ALL,
        icon: null,
        className: "buttonGreen",
    },
    {
        value: OrderFilterType.POS,
        icon: faLaptopMobile,
        className: "buttonBlue",
    },
    {
        value: OrderFilterType.MEETING_SERVICE,
        icon: faMug,
        className: "buttonPurple",
    },
]

export enum MeetingOrderFilterType {
    ALL = "ALL",
    RESOURCE_BOOKING = "RESOURCE_BOOKING",
    MEETING_SERVICE = "MEETING_SERVICE",
}

export const meetingOrderFilterButtonConfig: ButtonConfigType<MeetingOrderFilterType>[] = [
    {
        value: MeetingOrderFilterType.ALL,
        icon: null,
        className: "buttonGreen",
    },
    {
        value: MeetingOrderFilterType.RESOURCE_BOOKING,
        icon: faCalendarDay,
        className: "buttonBlue",
    },
    {
        value: MeetingOrderFilterType.MEETING_SERVICE,
        icon: faMug,
        className: "buttonPurple",
    },
]

export enum MeetingAudienceFilterType {
    ALL = "ALL",
    INTERNAL = "INTERNAL",
    EXTERNAL = "EXTERNAL",
}

// Order type for separating canteen and takeaway sales
export enum CanteenTakeawayFilterType {
    ALL = "ALL",
    LUNCH = "LUNCH",
    TAKE_AWAY = "TAKE_AWAY",
}

// Configuration for canteen / takeaway filtering buttons
export const canteenTakeawayFilterButtonConfig: ButtonConfigType<CanteenTakeawayFilterType>[] = [
    {
        value: CanteenTakeawayFilterType.ALL,
        icon: null,
        className: "buttonGreen",
    },
    {
        value: CanteenTakeawayFilterType.LUNCH,
        icon: faBagShopping,
        className: "buttonBlue",
    },
    {
        value: CanteenTakeawayFilterType.TAKE_AWAY,
        icon: faBurgerGlass,
        className: "buttonTeal",
    },
]
